import * as angular from 'angular';
import {BringozLoaderService} from "../../commons/services/bringoz-loader.service";
import {CancellationReasonsAlertsService} from "./cancellation-reasons-alerts.service";
import {CancellationReasonsRequestsService} from "./cancellation-reasons-requests.service";
import {ConfirmDialogService} from "../../commons/services/confirm-dialog.service";

export class CancellationReasonsService {

  constructor(private cancellationReasonsRequestsService: CancellationReasonsRequestsService, private cancellationReasonsAlertsService: CancellationReasonsAlertsService,
              private bringozLoaderService: BringozLoaderService, private $log, private confirmDialogService: ConfirmDialogService) {
  }

  createCancellationReason(cancellationReason) {
    return new Promise((resolve, reject) => {
      this.bringozLoaderService.on();
      this.cancellationReasonsRequestsService.createCancellationReason(cancellationReason)
        .then((updatedCancellationReason) => {
          this.cancellationReasonsAlertsService.createSuccess();
          resolve(updatedCancellationReason);
        })
        .catch((error) => {
          this.$log.error(error);
          this.cancellationReasonsAlertsService.createError();
          reject(error)
        })
        .finally(() => {
          this.bringozLoaderService.off();
        });
    });
  }

  updateCancellationReason(updatedCancellationReason) {
    return new Promise((resolve, reject) => {
      this.bringozLoaderService.on();
      this.cancellationReasonsRequestsService.updateCancellationReason(updatedCancellationReason)
        .then((cancellationReason) => {
          this.cancellationReasonsAlertsService.updateSuccess();
          resolve(cancellationReason);
        })
        .catch((error) => {
          this.$log.error(error);
          this.cancellationReasonsAlertsService.updateError();
          reject(error)
        })
        .finally(() => {
          this.bringozLoaderService.off();
        });
    });
  }

  deleteCancellationReason(cancellationReasonId) {
      const text = 'Are you sure you want to remove this cancellation reason?'
      return this.confirmDialogService.confirm('Remove Cancel Reason', text)
        .then(() => {
          return this._deleteCancellationReason(cancellationReasonId)
      })
  }

  private _deleteCancellationReason(cancellationReasonId) {
    return new Promise((resolve, reject) => {
      this.bringozLoaderService.on();
      this.cancellationReasonsRequestsService.deleteCancellationReason(cancellationReasonId)
        .then((removedCancellationReason) => {
          this.cancellationReasonsAlertsService.removeSuccess();
          resolve(removedCancellationReason);
        })
        .catch((error) => {
          this.$log.error(error);
          this.cancellationReasonsAlertsService.removeError();
          reject(error)
        })
        .finally(() => {
          this.bringozLoaderService.off();
        });
    });
  }

}

angular
  .module('bringoz.admin.cancellation-reasons')
  .service('cancellationReasonsService', CancellationReasonsService);
